import { render, staticRenderFns } from "./RevenueAndProfitStackedNotes.vue?vue&type=template&id=ae44baf2&scoped=true&"
import script from "./RevenueAndProfitStackedNotes.vue?vue&type=script&lang=js&"
export * from "./RevenueAndProfitStackedNotes.vue?vue&type=script&lang=js&"
import style0 from "./RevenueAndProfitStackedNotes.vue?vue&type=style&index=0&id=ae44baf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae44baf2",
  null
  
)

component.options.__file = "RevenueAndProfitStackedNotes.vue"
export default component.exports